export default "https://cdn-static.gokick.com/assets/e21cd8011b9b3a74c4cd288f1b94a870d12ac47c/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";